(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-panel-tipsen/assets/javascripts/participant.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-panel-tipsen/assets/javascripts/participant.js');
"use strict";

const {
  useSelector
} = ReactRedux;
const {
  ReactFlag
} = svs.lb_ui;
const {
  If
} = svs.components.lbUtils.reactConditionals;
const {
  TEAM_NAME_MAX_ALLOWED_LENGTH
} = svs.components.tipsen.drawSelectorComponents.constants;
const {
  selectParticipant,
  selectCountry
} = svs.components.sportinfo.matchInfoRedux.selectors;
const Participant = _ref => {
  let {
    participantId,
    index,
    additionalEventsCount
  } = _ref;
  const participant = useSelector(state => selectParticipant(state, participantId));
  const country = useSelector(state => selectCountry(state, participant.countryId));
  const presentableName = participant.name.length < TEAM_NAME_MAX_ALLOWED_LENGTH ? participant.name : participant.mediumName;
  const showAdditionalEventsCount = index === 1 && Boolean(additionalEventsCount);
  const isoCode = (country === null || country === void 0 ? void 0 : country.isoCode) || '';
  return React.createElement("li", {
    className: "participant"
  }, React.createElement("span", {
    className: "participant-flag"
  }, React.createElement(If, {
    condition: isoCode.length > 0
  }, React.createElement(ReactFlag, {
    iso: isoCode
  }))), React.createElement("span", {
    className: "participant-name"
  }, presentableName), React.createElement(If, {
    condition: showAdditionalEventsCount
  }, React.createElement("span", {
    className: "additional-events-count"
  }, "+".concat(additionalEventsCount))));
};
setGlobal('svs.components.tipsen.drawPanelTipsen.Participant', Participant);

 })(window);